import React from 'react'
import RenderPopoverComment from './RenderPopoverComment';

function RenderCommentParent({ index, rowsData, handleReason, reason,
  readOnly }: any) {
  //console.log(rowsData, "rows Data inside child Parent comment");
  const [anchorElComment, setAnchorElComment] = React.useState<HTMLButtonElement | null>(null);
  const handleClickComment = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElComment(event.currentTarget);
  };
  const handleCloseComment = () => {
    setAnchorElComment(null);
  };
  const openComment = Boolean(anchorElComment);
  const id = openComment ? 'simple-popover' : undefined;

  return (
    <>
      <button className='advance-payment-button' onClick={handleClickComment}  >
        <img
          className='image-top-wrapper-comment'
          src={"../../../../assets/images/comment.svg"}
        />
      </button>
      <RenderPopoverComment
        index={index}
        rowsData={rowsData}
        reason={reason}
        handleClickComment={handleClickComment}
        handleCloseComment={handleCloseComment}
        anchorElComment={anchorElComment}
        openComment={openComment}
        readOnly={readOnly}
        handleReason={(remarks: any, index: any) => {
          handleReason(remarks, index);
        }}
      />
    </>
  )
}

export default RenderCommentParent